document.addEventListener('DOMContentLoaded', () => {
  const pagetop = document.querySelector('.pagetop');

  // スクロール位置が変更されたときの処理
  window.addEventListener('scroll', () => {
    if (window.scrollY === 0) {
      // ページのスクロールが一番上にある場合、pagetopを非表示にする
      pagetop.style.opacity = '0';
      pagetop.style.pointerEvents = 'none'; // クリックを無効化
    } else {
      // ページがスクロールされている場合、pagetopを表示する
      pagetop.style.opacity = '1';
      pagetop.style.pointerEvents = 'auto'; // クリックを有効化
    }
  });

  // ページトップにスクロールするクリックイベント
  pagetop.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // スムーズスクロール
    });
  });
});
